import { Axios } from '@/axios/axiosPlugin'
import AgriConfig from '@/prototype/config'

// initial state
const state = {
    default_avatar: 'https://www.gravatar.com/avatar/default?s=150&r=pg&d=mm',

    is_admin: false,
    language: 'zh-Hant-TW',

    location_history: undefined,
    userBrowser: undefined,
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {

    // 檢查瀏覽器資訊
    check_Browser (state) {

        // Get the user-agent string
        let userAgentString = navigator.userAgent;

        // Detect Chrome
        let chromeAgent =
            userAgentString.indexOf("Chrome") > -1;

        // Detect Internet Explorer
        let IExplorerAgent =
            userAgentString.indexOf("MSIE") > -1 ||
            userAgentString.indexOf("rv:") > -1;

        // Detect Firefox
        let firefoxAgent =
            userAgentString.indexOf("Firefox") > -1;

        // Detect Safari
        let safariAgent =
            userAgentString.indexOf("Safari") > -1;

        // Discard Safari since it also matches Chrome
        if ((chromeAgent) && (safariAgent))
            safariAgent = false;

        // Detect Opera
        let operaAgent =
            userAgentString.indexOf("OP") > -1;

        // Discard Chrome since it also matches Opera
        if ((chromeAgent) && (operaAgent))
            chromeAgent = false;


        if ( safariAgent )      state.userBrowser = 'Safari'
        if ( chromeAgent )      state.userBrowser = 'Chrome'
        if ( IExplorerAgent )   state.userBrowser = 'IE'
        if ( operaAgent )       state.userBrowser = 'Opera'
        if ( firefoxAgent )     state.userBrowser = 'Firefox'

        // console.log( userAgentString )
        // console.log( 'Browser: ' + state.userBrowser )
    },

    set_Language (state, lang)
    {
        state.language = lang;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

